import styled from 'styled-components';

export const LeadPreviewStyle = styled.div`
  position: relative;
  display: flex;
`;
export const UserAsidBar = styled.div`
  flex-shrink: 0;
  width: 325px;
  padding: 25px 0;
  border-right: 1px solid #ddd;

  .user-info {
    width: 100%;
    text-align: center;
    padding: 0 20px 20px;
    border-bottom: 1px solid #ddd;

    .img-box {
      width: 85px;
      height: 85px;
      margin: 0 auto 13px;
      border-radius: 100px;
      overflow: hidden;

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .text-box {
      width: 100%;
    }

    .title {
      display: block;
      font-size: 18px;
      line-height: 22px;
      font-weight: 500;
      text-transform: capitalize;
      color: var(--black);
      margin: 0 0 10px;
    }
    .designation {
      display: block;
      font-size: 12px;
      line-height: 15px;
      font-weight: 400;
      color: #7f8594;
      margin: 0 0 10px;
    }
    .new-lead {
      display: inline-block;
      position: relative;
      min-width: 100px;
      padding: 8px 15px 8px 26px;
      margin: 0 0 18px;
      font-size: 12px;
      line-height: 16px;
      font-weight: 600;
      text-transform: capitalize;
      color: #317bff;
      border-radius: 50px;
      background: rgba(49, 123, 255, 0.1);

      &::before {
        content: '';
        position: absolute;
        top: 11px;
        left: 13px;
        width: 8px;
        height: 8px;
        border-radius: 50px;
        background: #317bff;
      }
    }
    .socialicons {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;

      li {
        width: 40px;
        height: 40px;
        border-radius: 50px;
        background: #f2f4fc;
      }
    }
  }

  .detail {
    padding: 20px;
    border-bottom: 1px solid #ddd;

    .info-list {
      list-style: none;
      font-size: 12px;
      line-height: 16px;
      margin: 0;
      padding: 0;

      li {
        display: flex;
        align-items: center;
        gap: 10px;
        margin: 0 0 13px;

        &:last-child {
          margin: 0;
        }
      }

      .subtitle {
        min-width: 70px;
        color: #7f8594;
      }
      .text {
        display: block;
        color: #282828;
        font-weight: 600;
      }
    }

    .select-box {
      display: flex;
      align-items: center;
      gap: 8px;
      position: relative;
      flex-grow: 1;
      font-weight: 600;
      color: #83899f;
      padding: 5px 30px 5px 10px;
      border: 1px solid #e6e7ec;
      border-radius: 5px;
      cursor: pointer;

      .arrow {
        position: absolute;
        top: 50%;
        right: 3px;
        transform: translateY(-50%);
        font-size: 20px;
        color: #317bff;
      }

      &.open {
        border-color: #3b82f6;
        background: #f1f5ff;

        .arrow {
          transform: translateY(-50%) scale(-1);
        }
      }

      .item {
        display: flex;
        align-items: center;
        gap: 8px;
        margin: 0;
        font-weight: 500;
        color: #317bff;
      }

      .img-box {
        width: 20px;
        height: 20px;
        border-radius: 50px;
        overflow: hidden;

        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .select-drop {
        list-style: none;
        position: absolute;
        top: 100%;
        right: 0;
        padding: 12px;
        margin: 12px 0 0;
        width: 100%;
        border-radius: 12px;
        text-align: center;
        background: var(--white);
        border: 1px solid rgba(222, 222, 222, 0.5);
        z-index: 2;

        li {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 2px 10px;
          margin: 0 0 12px;
          border-radius: 5px;
          border: 1px solid #e6e7ec;

          &:last-child {
            margin: 0;
          }
        }
      }
    }

    /* Tag Select */
    .tag-select {
      border-color: rgba(255, 200, 49, 0.1);
      background: rgba(255, 200, 49, 0.1);

      &.open {
        border-color: rgba(255, 200, 49, 0.2);
        background: rgba(255, 200, 49, 0.2);
      }

      .arrow {
        color: #ffc831;
      }

      .item {
        color: #ffc831;
      }

      .select-drop {
        li {
          display: block;
          padding: 5px 10px;
          border: 0;
          background: rgba(255, 200, 49, 0.1);
        }
      }
    }

    /* Lead Status Select */
    .status-select {
      border-color: rgba(13, 160, 106, 0.1);
      background: rgba(13, 160, 106, 0.1);

      &.open {
        border-color: rgba(13, 160, 106, 0.2);
        background: rgba(13, 160, 106, 0.2);
      }

      .arrow {
        color: #0da06a;
      }

      .item {
        color: #0da06a;
      }

      .select-drop {
        li {
          display: block;
          padding: 5px 10px;
          border: 0;
          background: rgba(13, 160, 106, 0.1);
        }
      }
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateY(-4px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }
`;
export const ContentWrap = styled.div`
  flex-grow: 1;

  .tabset-list {
    list-style: none;
    margin: 0;
    padding: 10px;
    display: flex;
    align-items: center;
    gap: 10px;
    border-bottom: 1px solid #ddd;

    .btn-tab {
      display: block;
      font-size: 14px;
      line-height: 18px;
      font-weight: 600;
      text-transform: capitalize;
      padding: 7px 20px;
      border-radius: 50px;
      color: #7f8594;
      background: var(--white);

      &.active {
        color: var(--black);
        background: #f2f4fc;
      }
    }
  }

  .tabs-content {
    padding: 15px 20px;
    height: calc(100dvh - 115px);
    overflow-y: auto;
   transition: all 0.350s ease-in-out;

        .trial-banner-visible & {
            height: calc(100dvh - 160px);

            }

    .communication-content {
      height: 100%;
      margin: -15px -20px;
    }
  }
`;
export const ActivityTabStyle = styled.div`
  position: relative;

  .text-holder {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 15px 0;
    font-size: 14px;
    line-height: 18px;
    color: #282828;

    .wrap {
      display: flex;
      align-items: start;
      gap: 10px;
      flex-grow: 1;
    }

    .img-box {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: 40px;
      height: 40px;
      padding: 5px;
      border-radius: 50px;
      overflow: hidden;
      background: rgba(39, 131, 236, 0.1);
    }

    .text-box {
      max-width: 700px;
      font-weight: 500;
      color: #282828;

      .title {
        display: block;
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
        color: #0e0e11;
        margin: 0 0 5px;
      }
      .text {
        display: block;
        font-size: 14px;
        line-height: 18px;
        font-weight: 500;
        color: #d0d0d0;
      }
    }

    .time-col {
      flex-shrink: 0;
      text-align: right;
      font-size: 12px;
      line-height: 15px;
      color: #666668;

      .date {
        display: block;
        font-weight: 500;
      }
      .time {
        display: block;
        font-weight: 300;
      }
    }
  }
`;
export const CommunicationTabStyle = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background: var(--white);
  height: 100%;

  .no-found {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .messages-wrapper {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    padding: 16px;
    position: relative;

    .messages-holder {
      flex-grow: 1;
      height: calc(100vh - 320px);
      overflow: auto;
      padding: 0 5px 0 0;

      &::-webkit-scrollbar {
        width: 4px;
      }
      .infinite-scroll-component {
        display: flex;
        flex-direction: column-reverse;
      }
    }

    .email-opened {
      display: flex;
      align-items: center;
      gap: 10px;
      margin: 0 0 12px;

      .icon-holder {
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #e8e9f1;
        border-radius: 50%;
      }

      .text-holder {
        flex-grow: 1;

        .email-heading {
          font-weight: 400;
          font-size: 14px;
          line-height: 18px;
        }
      }
    }
  }

  .input-holder {
    .wrap {
      position: relative;
      padding: 2px 3px 33px;
      border-radius: 13px;
      background:#f2f4fc;
    }

    .response-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      font-size: 12px;
      line-height: 15px;
      font-weight: 500;
      padding: 5px;

      .response-text {
        display: flex;
        align-items: center;
        gap: 5px;
        color: var(--blue);
        cursor: pointer;
      }

      .user-email-select {
        .react-select__control{
          height: 35px;
          font-size: 12px;
          line-height: 16px;
          padding-right:0;
          padding-left:8px;
        }
      }
    }

    .textarea {
      padding: 10px;
      width: 100%;
      height: 90px;
      border: none;
      outline: none;
      border-radius: 10px 10px 0 0;
      background: var(--white);
      resize: none;
      font-family: var(--base-font-sans-serif);
      font-size: 14px;
    }

    .toolbar {
      display: flex;
      align-items: center;
      gap: 10px;
      height: 30px;
      position: absolute;
      left: 3px;
      right: 3px;
      bottom: 3px;
      padding: 5px;
      border-radius: 0 0 10px 10px;
      background: var(--white);

      .btn-wrap {
        flex-grow: 1;
        display: flex;
        align-items: center;
        gap: 13px;

        .btn {
          font-size: 16px;
          color: #7f8594;
          background: transparent;
          border: none;
          cursor: pointer;
          padding: 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .btn-submit {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        color: var(--white);
        margin: 0 0 8px;
        border-radius: 50px;
        background: var(--blue);
        border: none;
        cursor: pointer;

        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
      }
    }
  }
`;
export const NotesTabStyle = styled.div`
  position: relative;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    .heading {
      display: flex;
      font-size: 16px;
      line-height: 20px;
      font-weight: 600;
      color: var(--black);
    }
  }

  .note-block {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    position: relative;
    padding: 18px;
    margin: 0 0 12px;
    border: 1px solid #e6e7ec;
    border-radius: 12px;

    .text-col {
      flex-grow: 1;

      .time {
        display: block;
        font-size: 10px;
        line-height: 13px;
        font-weight: 300;
        color: #666668;
        margin: 0 0 6px;
      }
      .title {
        display: block;
        font-size: 16px;
        line-height: 19px;
        font-weight: 600;
        color: #2c2c2e;
        margin: 0 0 6px;
      }
      .description {
        display: block;
        font-size: 14px;
        line-height: 18px;
        color: #7f8594;
      }
    }

    .right-col {
      display: flex;
      align-items: center;
      gap: 77px;
    }
    .img-list {
      display: flex;
      align-items: center;
      gap: 8px;

      .img-box {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 66px;
        height: 66px;
        border-radius: 12px;
        overflow: hidden;
        background: #f4f9fe;
      }
    }
    .btn-open {
      width: 24px;
      align-self: self-start;
    }
  }
`;
